const Data = [
  {
    name: '通用操作',
    id: '1',
    children: [
      {
        name: '基本概念',
        id: '1',
        list: [
          {
            id: '1',
            time: '2020-10-11 12:30:07',
            q:
              '有没有动态获取token的API？控制台复制到10小时有效期的token，不能用于长期测试，或者可以获取到时间更长的Token可以在开发期间使用？',
            a:
              '在控制台申请帐户后，使用注册的client_id和client_serect，通过callback回调函数进行动态获取token值。',
          },
          {
            id: '2',
            time: '2020-10-11 12:30:07',
            q:
              '如果我在外部获取token，然后通过BuildAppLication传入Token是否有可能，目前看到的是必须要通过回调函数？',
            a: 'getAccessToken()方法必须通过回调函数进行使用，在内部使用。',
          },
          {
            id: '3',
            time: '2020-10-11 12:30:07',
            q: '模型中构件的dbId是否能唯一确定一个构件？多次加载后，dbId会不会变化？',
            a:
              '可以，同一个模型文件加载后，每个构件会有对应的唯一dbId；重复加载，对dbId并不会造成影响；如果对文件进行修改可能会造成变化。',
          },
          {
            id: '4',
            time: '2020-05-21',
            q:
              '之前有看到过BIM模型的核心数据规范，以及数据的组织形式。那么，是否通过BIMBase云平台（OBV）提供出来模型，也有类似的规范？例如，模型中包括哪些墙体，墙体数据的命名、电气数据的命名规范，数据的组织形式等等。',
            a:
              '关于BIM标准，BIMBase云平台（OBV）只是轻量化展示模型，不会涉及到一些标准，构件的标准是在建模的时候规定的，包括构件的属性都是在建模时候确定到构件信息中，BIMBase云平台（OBV）只是将它们展示出来，三维建模软件所带有的构件信息，在BIMBase云平台（OBV）这边都会有的。',
          },
          {
            id: '5',
            time: '2022-06-27',
            q: '流式和全量（加载/转换）是什么意思?',
            a:
              'BIMBase云平台（OBV）有两种轻量化数据格式，流式与全量。这两种数据相互独立，加载前需要进行指定转换，称为流式转换与全量转换。' +
              '<br/>' +
              '&nbsp;&nbsp;&nbsp;&nbsp;流式：ptiles格式。流式加载采用LOD 加载方式，模型数据以瓦片形式组织。流式加载会大幅提升模型加载的速度及浏览性能，推荐使用。' +
              '<br/>' +
              '&nbsp;&nbsp;&nbsp;&nbsp;流式加载效果截图：' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/lodloading.gif" style="width:500px;margin-left:20px;">' +
              '<br/>' +
              '&nbsp;&nbsp;&nbsp;&nbsp;全量：pmodel格式。全量加载特点是先请求全部模型数据后再一次性加载，加载完成之后的模型浏览操作将不会再额外请求模型几何数据，整体浏览体验较好，但大模型加载场景中，前期的加载等待时间可能会偏长（具体等待时间受下载网速和客户端硬件配置高低影响）。' +
              '<br/>' +
              '&nbsp;&nbsp;&nbsp;&nbsp;全量加载效果截图：' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/obvloading.gif" style="width:500px;margin-left:20px;">'
          },
          {
            id: '6',
            time: '2022-06-27',
            q: '动态内存调度是什么？动态内存调度的优点及适用的场景是哪些？',
            a:
              '1.动态内存调度是什么？<br/>动态内存调度是基于流式数据格式（LOD），为解决电脑硬件配置不足的情况下加载大体量BIM模型数据需求的一种调度机制，根据计算机配置，自主分配加载模型时的可用内存。<br/><br/>' +
              '2.动态内存调度的优点：<br/>当下，使用计算机加载BIM模型时，大模型和小内存的矛盾极易引起内存崩溃的现象。动态内存调度可根据模型和内存的大小，按照视域加载模型。比如：计算机只有4G的内存，但加载的模型需要占用5G的内存，动态内存调度则会选择先粗略级加载模型整体结构（完整的模型个数以及整个模型的外部轮廓等），然后再按照剩余可用内存的实际情况，由近及远加载精细级别的模型构件，当内存占用达到阈值上限则停止其余精细级别数据加载，通过鼠标交互操作场景改变观察视角后，根据视域动态更新模型精细级别数据，在保证相对平稳的内存占用及浏览器页面稳定的前提下，满足大模型的查看与业务功能的实现。<br/><br/>' +
              '3.动态内存调度适用于哪些场景？<br/>动态内存调度适用于加载任何模型，但一般推荐在加载大体量单体模型及合模时使用。'

          },
          {
            id: '7',
            time: '2022-08-25',
            q: '环境光阴影是什么？环境光阴影的优缺点是什么？环境光阴影适用的场景是什么?',
            a:
              '1.环境光阴影是什么？<br/>由主光产生的清晰、定向的投影称为主阴影。由各个角度出现的环境光产生的弥散、柔和的阴影称为环境阴影。<br/><br/>' +
              '2.环境光阴影的优缺点是什么？<br/>优点是让光影效果更逼真；缺点是会比较耗费性能，但不需要时可保持关闭状态。<br/><br/>' +
              '3.环境光阴影适用的场景是什么?<br/>适用于部分模型层次感不强或需要通过局部阴影加强层次感的场景。' +
              '<br/>' +
              '环境光阴影的展示效果详情可参考示例' +
              '<div style="padding-left: 20px"><a href="../../../../playground/lod?sampleID=Ambientlightshadow" target="_black">点击查看代码示例</a></div>'
              + '<br/>' +
              '开启环境光阴影的步骤：点击设置->选择渲染->太阳光阴影开启，详情可参考下图' +
              '<img src="../../../../static/img/commonQuestion/007.png" style="width:80%;margin-left:20px;">' +
              '<br/>' +
              '环境光阴影关闭的展示效果如下图所示：' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/005.png" style="width:80%;margin-left:20px;">' +
              '<br/>' +
              '<br/>' +
              '环境光阴影开启的展示效果如下图所示：' +
              '<img src="../../../../static/img/commonQuestion/006.png" style="width:80%;margin-left:20px;">'
          },
          {
            id: '8',
            time: '2024-04-02',
            q: 'OBV是左手坐标系还是右手坐标系？',
            a:
              '右手坐标系'
          }
        ],
      },
      {
        name: '基础操作',
        id: '2',
        list: [
          {
            id: '1',
            time: '2020-10-12 11:20:47',
            q: '使用OBV5时加载模型的部分内置插件，控制台为什么会出现报错?',
            a:
              'OBV5将漫游和剖切插件自动加载到了工具栏中，不需要外部引入进行加载，如果重复加载插件，控制台就会报错。',
          },
          {
            id: '2',
            time: '2022-01-11',
            q: '加载多个模型时，为什么会出现加载卡在0%的情况？',
            a:
              '为了提供产品稳定性，BIMBase云平台（OBV）近期对模型加载进行了优化，现在不接受完全加载完一个模型后再去加载另一个模型了，' +
              '<br/>' +
              '例：加载两个模型，需要改成先加载完两个模型的document数据，再去加载模型。' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/loadMultModel.png" style="width:60%;margin-left:20px;">',
          },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      // {
      //     name: '格式支持',
      //     id: '3',
      //     list: [
      //         {
      //             id: '1',
      //             time: '2024-06-30',
      //             q: '图模大师/OBV支持哪些主流格式的最新版本文件？',
      //             a: '支持版本如下：' +
      //             '<img src="../../../../static/img/commonQuestion/type-version.png" style="width:60%;margin-left:20px;">',
      //         },
              // {
              //     id: '2',
              //     time: '',
              //     q: '',
              //     a: '',
              // },
              // {
              //     id: '3',
              //     time: '',
              //     q: '',
              //     a: '',
              // },
          // ],
      // },
    ],
  },
  {
    name: '模型浏览',
    id: '2',
    children: [
      {
        name: '查看模型',
        id: '1',
        list: [
          {
            id: '1',
            time: '2021-05-21',
            q: '从revit导出模型后上传转换完成，用BIMBase云平台（OBV）打开点主视图看不见模型？',
            a:
              '有两种情况可能导致在BIMBase云平台（OBV）中主视图看不到模型。' +
              '<br/>' +
              '1、插件导出时默认使用revit的相机信息，如果在导出时相机本身不是看向目标建筑，有可能导致插件导出了错误的相机信息，这时可以尝试点击全视图检查能否看到模型。' +
              '<br/>' +
              '2、模型中在非常远的位置存在一些不可见构件，导致导出后的整个模型坐标范围特别大，主体模型很小在页面上难以分辨，这时可以点击剖切，借助剖切框检查模型包围盒大小以确定问题。',
          },
          {
            id: '2',
            time: '2021-05-21',
            q: '一些模型在BIMBase云平台（OBV）中查看时，构件表面出现颜色重叠、花影，显示效果不好是什么原因？',
            a:
              '这种构件表面重叠的现象叫做“z-fighting”，出现这种情况可能存在以下几方面的原因：' +
              '<br/>' +
              '1、在建模过程中两个构件的表面位置完全重合，这样在显示过程中两个构件抢占同一个像素处对应的位置，就会出现‘z-fighting’现象，这个可以考虑在建模过程中尽量避免构件的位置重合以避免此问题；' +
              '<br/>' +
              '2、部分模型的整体坐标跨度非常大，如果在加载模型时还设置了偏移值，这会导致整体的计算误差增大从而导致‘花影’，这个可以考虑在加载模型时不指定偏移值（注意：不指定偏移值不是将modelOffset设为0，而是不传入modelOffset这个参数）;' +
              '<br/>' +
              '3、可以考虑在设置中选择【渲染-正面】选项。',
          },
          {
            id: '3',
            time: '2021-05-21',
            q: '为什么在设置中开启缓存后加载速度还是很慢？',
            a:
              '在模型加载的中途开启缓存，实际这些数据并没有在这次缓存开启后就缓存到浏览器本地，而是需要打开缓存的开关后再重新加载一次，这样才会缓存到本地。 或者可以使用BIMBase云平台（OBV）提供的接口设置在加载模型前就开启缓存， BIMBase云平台（OBV）.SettingsController.instance.enableCache = true。',
          },
          {
            id: '4',
            time: '2021-05-21',
            q: '为什么选择开启x光模式后看不到效果？',
            a:
              'x光模式是在有构件被隔离或者隐藏时，使用类似x光照片的形式显示被隐藏的构件，所以需要在隐藏或者隔离构件时才会看到效果。',
          },
          {
            id: '5',
            time: '2021-05-21',
            q: '设置中显示线的作用是什么？为什么我在模型中开启这一功能后看不到变化？',
            a:
              '显示线表示显示模型的边线数据，打开显示线功能能够提高模型的显示效果，使模型更具有层次感，显示线功能需要在导出模型时导出了模型的边线数据后使用才会有效果的变化。',
          },
          {
            id: '6',
            time: '2021-05-21',
            q: '为什么xxx接口调用时报错（或者没有生效）？',
            a:
              'BIMBase云平台（OBV）中一些接口是需要在特定的时机下使用才会生效的，比如V3dPropertiesLoaded事件触发之后才可以获取到构件属性，如果某个接口使用时报错，可以先在官网的示例、图模大师、或者创建一个单独的示例，试验调用接口是否存在问题，如果试验没问题，那可能是项目中的调用方式有问题，这时就需要根据项目进行排查。',
          },
          {
            id: '7',
            time: '2021-07-22',
            q: '为什么在操作模型很卡顿，在图模大师上传同样的模型却正常？',
            a:
              '如果使用vue编写代码，注意不要把BIMBase云平台（OBV）返回的obvApi放置到data或state中，vue的双向绑定机制会异常监听变化并更新从而导致卡顿。需要将obvApi存到静态变量中。',
          },
          {
            id: '8',
            time: '2021-11-08',
            q: '为什么在笔记本电脑上查看模型加载很慢，在台式电脑上查看模型却正常？',
            a:
              '笔记本慢可能跟显卡模式、省电模式有关系。' +
              '<br/>' +
              '显卡默认情况下是不开启高性能模式的，在查看模型时比较吃力时，可以尝试<a href="https://jingyan.baidu.com/article/af9f5a2dfd7de603140a4598.html" target="_black">开启显卡的高性能模式</a>。' +
              '<br/>' +
              '省电模式会将主频降低从而达到省电的目的。主频降低后性能会受到一定程度的影响。建议调回家用办公桌的模式。',
          },
          {
            id: '9',
            time: '2022-04-11',
            q: '为什么用浏览器加载/查看模型容易崩溃？',
            a:
              '<div>模型频繁崩溃可能跟使用的浏览器有关，推荐使用<a href="https://www.google.cn/intl/zh-CN/chrome/" target="_black">64位的谷歌浏览器</a>，并且开启 --no-sandbox 选项。</div>' +
              '<div>右击桌面Google Chrome -属性-快捷方式-目标，添加【 --no-sandbox】，重启Google Chrome即可。</div>',
          },
          {
            id: '10',
            time: '2023-02-15',
            q: '模型轻量化时，是按照文件中哪个视图为准进行转换的？为什么 没有显示最后保存的视图？',
            a:
              '<div>轻量化时先识别视图名称为  三维  的视图，跟最后保留的视图是哪一个没有关系</div>',
          },
          {
            id: '11',
            time: '2023-04-28',
            q: '栅格等构件出现锯齿显示怎么办？如何调节抗锯齿显示效果？',
            a:
              '<div>在模型设置-显示效果中，提供了抗锯齿效果 显示设置选项，按照效果与效率分为最佳、自适应、默认与普通选项，BIMBase云平台会根据设置的效果选项与当前显示帧率平衡最优的显示方案。</div>' +
              '<div style="margin-left: 15px">1、最佳选项：为抗锯齿效果最优选项，始终保持最佳抗锯齿效果，不再监测帧率；</div>' +
              '<img src="../../../../static/img/commonQuestion/best-option.png" style="width:95%;margin-left:20px;">' +
              '<div style="margin-left: 15px">2、自适应选项：自动监测当前帧率，如果帧率持续下降120帧（低于24帧每秒视为下降）当前模型自动切换到默认抗锯齿；在未切换到默认抗锯齿前拥有最佳50%的抗锯齿效果保留以及50%性能提升；</div>' +
              '<img src="../../../../static/img/commonQuestion/adaptive-option.png" style="width:95%;margin-left:20px;">' +
              '<div style="margin-left: 15px">3、默认选项：为抗锯齿效果良好同时显示效率较高的选项；</div>' +
              '<div style="margin-left: 15px">4、普通选项：为抗锯齿效果一般但显示效率高的选项；</div>',

          },
        ],
      },
      {
        name: '模型属性',
        id: '2',
        list: [
          {
            id: '1',
            time: '2020-10-12 13:30:19',
            q: '如果想要获取模型的信息，应该怎么获取？模型上具体保存了哪些信息？',
            a:
              '模型信息是从模型文件中导入的，如果模型文件中对于该构件的构件属性有您想要获取的信息，就可以在属性面板或者调用API获取到。',
          },
          {
            id: '2',
            time: '2020-10-12 13:30:19',
            q: '如何获取一个窗户的属性？',
            a:
              '选中构件后，通过监听选中的构件信息，就可以通过obvApi.getProperties(nodeId).then();这个方法对构件进行查询。',
          },
          {
            id: '3',
            time: '2020-10-12 14:32:36',
            q: '模型中保存的属性只有工具栏里“属性菜单”中的属性吗？',
            a: '是的。',
          },
          {
            id: '4',
            time: '2020-10-12 14:32:45',
            q:
              '加载模型后，模型的modelId是怎么生成的，是按照加载顺序递增吗？如何通过API判断一个场景中有几个model？',
            a:
              'modelId的生成不是固定的，是按照加载模型的顺序递增，需要根据当前加载的模型数量进行统计；调用obvApi.getmodelIds()这个接口访问modelId数量，该接口返回一个数组，这个数组就是模型文件的modelId属性。',
          },
          {
            id: '5',
            time: '2020-10-12 14:33:22',
            q: '关于构件属性，是初始建模的时候就添加的吗？构件属性的结构体是否是固定的？',
            a: '是的，构件属性是在建模过程中就添加好的。结构体也是固定的，这些信息在属性面板都有展示。',
          },
        ],
      },
      {
        name: '模型显示',
        id: '3',
        list: [
          {
            id: '1',
            time: '2021-11-29',
            q: '模型加载的缓存数据存储在哪里？有没有删除模型缓存数据的API？',
            a:
              '<div>开启缓存会把数据写到浏览器的IndexDB中（浏览器开发者工具 >> Application >> Storage >> IndexDB），默认最多可以缓存20个模型。</div>' +
              '<div>若存储到达上限，后续模型加载将不会缓存；与电脑配置相关，若电脑C盘空间不足，IndexDB可能不会写入，模型将无法缓存。</div>' +
              '<img src="../../../../static/img/commonQuestion/modelCacheData.png" style="width:50%;margin-left:20px;">' +
              '<br/><br/>' +
              '<div>目前没有删除模型缓存数据的API，需要手动删除。选中PKPM_OBV_MODEL，点击Delete database即可删除。</div>' +
              '<img src="../../../../static/img/commonQuestion/modelCacheData_delete.png" style="width:50%;margin-left:20px;">',
          },
        ],
      },
      {
        name: '构件信息',
        id: '4',
        list: [
          {
            id: '1',
            time: '2020-10-12 14:34:13',
            q: '现在的构件都是相对比较精细的，当前有没有组合构件的手段？',
            a:
              '<div>没有组合构件这个功能，但是我们有几种方法，可以获取到房间：</div>' +
              '<div>&nbsp;&nbsp;&nbsp;&nbsp;1.通过模型树获取该OBVID的父节点，如果该模型树的层级关系是 房屋-构件 的话，我们可以获取到整个屋子。</div>' +
              '<div>&nbsp;&nbsp;&nbsp;&nbsp;2.建模的时候，把房间看成一个整体，这样就可以选中房间，但是房间中的构件无法被选中。</div>' +
              '<div style="padding-bottom: 80px;">&nbsp;&nbsp;&nbsp;&nbsp;3.在建模的时候，给房间加上自定义属性，这样我们通过 search 进行属性查找，就可以获取到这个房间。</div>',
          },
          {
            id: '2',
            time: '2020-10-12 14:40:38',
            q: 'getProperties()接口只能查询一个构件属性，是否有获取多个构件属性的API？',
            a: 'getPropertiesList()接口，以数组的方式传入多个构件的nodeId，即可获得多个构件的信息。',
          },
          {
            id: '3',
            time: '2021-05-21',
            q: 'BIMBase云平台（OBV）中使用的单位是什么？',
            a:
              '常见单位分为公制单位和英制单位，BIMBase云平台（OBV）中坐标系中以公制单位米（符号：m）为单位。如果模型使用英制单位如英尺（符号：ft），那么在BIMBase云平台（OBV）中显示模型时会转换为米为单位。例如：模型总长度为10英尺，在BIMBase云平台（OBV）中获取到的模型长度为3.048米。获取模型包围盒时，也会获取到以米为单位的包围盒大小。加载模型时设置模型偏移modelOffset的值会根据模型的单位转换为对应的米的距离。',
          },
          {
            id: '4',
            time: '2021-07-14',
            q: '在BIMBase云平台（OBV）里，模型的单个构件可以移动吗，只想拖动单个构件，是要怎么操作？',
            a:
              '可以通过接口实现单个构件的移动。官网有个<a href="../../../../playground/lod/?sampleID=modelExplosion" target="_black">爆炸视图的示例</a>，移动构件也是用这个接口（如图一）。setComponentExploded对应接收一个drawable的数组和移动矩阵的数组 ，如果只移动一个构件 drawableIdList就是一个只有一个值的数组，后面的matrixList也是一个数组（如图二）。我们是通过drawableId来管理这些构件的，通过操作drawableId来控制这些构件的展示，获取到构件的drawableId之后组装成一个drawableId的数组传进去就可以了。drawableId就是每一个构件对应的可绘制对象，是实际在canvas上画出来的东西。' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/remove-group-1.png" style="width:50%;margin-left:20px;">' +
              '<br/>' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/remove-group-2.png" style="width:50%;margin-left:20px;">',
          },
          {
            id: '5',
            time: '2023-04-11',
            q: '怎样获取一个模型的所有子节点dbId?',
            a:
              '在模型加载完成后，通过遍历模型树查找到所有叶子节点，其中没有children属性的node节点就是子节点。合模时需要等待模型全部加载完成后再针对每个模型遍历：' +
              '<br/>' +
              '<br/>' +
              '<img src="../../../../static/img/commonQuestion/getChildrenNode.png" style="width:80%;margin-left:20px;">',
          },
        ],
      },
    ],
  },
  {
    name: '扩展功能',
    id: '3',
    children: [
      // {
      //     name: '标注管理',
      //     id: '1',
      //     list: [
      //         {
      //             id: '1',
      //             time: '',
      //             q: '',
      //             a: '<img src="../../../../static/img/aecworks-ewm.png" style="height:50px;margin-left:20px;">',
      //         },
      //         {
      //             id: '2',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '3',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //     ],
      // },
      {
        name: '批注管理',
        id: '2',
        list: [
          {
            id: '1',
            time: '2021-08-16',
            q: ' 为什么导出的批注无法显示截图？',
            a:
              '导出批注无法显示截图有以下两种解决办法：' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;1.排查该文件是否被移动、重命名或删除；' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;2.用WPS代替Office打开【调整意见书.doc】，建议使用2019及以上版本的WPS，因为低版本的WPS兼容性不好，也有可能无法显示截图；',
          },
          // {
          //     id: '2',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      {
        name: '轴网管理',
        id: '3',
        list: [
          {
            id: '1',
            time: '2023-11-13',
            q: ' 为什么图模大师有轴网显示按钮，我加载模型没有？',
            a:
              '能够显示轴网的条件：' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;1、原模型中包含轴网数据；' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;2、模型使用插件导出或者线上转换时导出了轴网数据；' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;3、OBV加载模型时加载了轴网数据。' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;<a href="../../../../playground/lod?sampleID=obvPlugIn" target="_black">前端加载轴网插件示例</a>'
          },
          {
            id: '2',
            time: '2023-11-13',
            q: ' 为什么模型没有轴网数据？',
            a:
              '能够显示轴网的条件：' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;1、原模型中包含轴网数据；' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;2、模型使用插件导出或者线上转换时导出了轴网数据；' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;3、OBV加载模型时加载了轴网数据。' +
              '<br />' +
              '&nbsp;&nbsp;&nbsp;&nbsp;<a href="../../../../playground/lod?sampleID=obvPlugIn" target="_black">前端加载轴网插件示例</a>'
          },
          {
            id: '3',
            time: '2023-11-13',
            q: ' 轴网有什么作用？',
            a:
              '轴网是可帮助整理设计的注释图元。 将轴线添加到模型中，可以创建设计的参照和框架。'
          },
          // {
          //     id: '2',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
    ],
  },
  {
    name: '交互功能',
    id: '4',
    children: [
      {
        name: '监听事件',
        id: '1',
        list: [
          {
            id: '1',
            time: '2020-10-12 16:45:48',
            q: '加载模型完成后点选一个构件，能否在点选构件后，回调自己定义编写的处理方法？',
            a: '点选构件后，可以在V3dSelectionChangedEvent 监听事件中进行自定义的处理方法。',
          },
          {
            id: '2',
            time: '2024-04-02',
            q: '模型加载的监听事件返回为什么与实际加载情况不符？',
            a: '全量数据监听要在load3dModels之前，模型加载完了就不能监听了；流式数据加载没有限制',
          },
          {
              id: '3',
              time: '2024-06-30',
              q: '既要监听V3dPropertiesLoadedEvent又要监听V3dGeometryLoadedEvent时，应该怎么处理呢？',
              a: '使用多个监听时，可以在单个监听事件完成后，用不同的参数表示，当所有参数值都变化了，就代表监听都执行完成了。具体实现可参考<a href="../../../../playground/lod/?sampleID=modelComparison" target="_black">对比加载示例</a>；',
          },
        ],
      },
      {
        name: '工具栏',
        id: '2',
        list: [
          {
            id: '1',
            time: '2021-05-21',
            q: '如果我们在页面上自定义工具栏按钮，而又需要调用工具栏上的功能，应该使用哪些API？',
            a:
              '工具栏上用到哪些功能，需要根据功能需求来提供对应的接口；最后通过element元素和js自己创建工具栏按钮添加到viewer中。',
          },
          // {
          //     id: '2',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      // {
      //     name: '导航功能',
      //     id: '3',
      //     list: [
      //         {
      //             id: '1',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '2',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '3',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //     ],
      // },
    ],
  },
  {
    name: '后端服务',
    id: '5',
    children: [
      {
        name: '模型上传',
        id: '1',
        list: [
          {
            id: '1',
            time: '2020-10-14 10:45:08',
            q: '前端上传截图方式没有上传成功？',
            a: '尝试换一种格式，将 data: {\'file\': file} 更改为 data: file 形式。',
          },
          {
            id: '2',
            time: '2020-10-14 10:45:10',
            q: '上传文件以后，通过文件获取无法找到上传文件，怎么办？',
            a:
              '通过查询如果大多数文件可以查询到，只有个别文件无查询结果，可能是因为中文路径的原因，路径中文件的名称不可以带空格，查询如果必须有空格，可以加上 %20 用于转义空格。',
          },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      {
        name: '模型转换',
        id: '2',
        list: [
          {
            id: '1',
            time: '2020-10-14 13:25:48',
            q: '如何实现文件转换？',
            a:
              '<div> 首先我们要创建一个bucket（桶），然后创建object（文件）。</div>' +
              '<img src="../../../../static/img/commonQuestion/changeModel-createObject.png" style="width: 65%;height: auto">' +
              '<div> Bucketkey 和 objectkey 是文件的某个实例，在我们创建了 bucketkey 和 objectkey 之后通过接口上传模型文件，然后我们获取到一个文件的urn值。</div>' +
              '<img src="../../../../static/img/commonQuestion/changeModel-urn.png" style="width: 60%;height: auto">' +
              '<div> 我们编写了urn之后，再加上转换类型，即可实现文件转换。</div>' +
              '<div style="color: #b1240c">注意：必须是 "Content-Type: application/octet-stream"。请注意不要与已有的 bucket 重复。</div> ' +
              '<img src="../../../../static/img/commonQuestion/changeModel-job-1.png" style="width: 60%;height: auto">' +
              '<img src="../../../../static/img/commonQuestion/changeModel-job-2.png" style="width: 60%;height: auto;padding-bottom: 80px;">',
          },
          {
            id: '2',
            time: '2020-10-14 13:25:52',
            q: '可以实现的文件转换类型有哪些？',
            a:
              '<div>我们支持70余种转换类型，目前指支持下方链接中的存储格式，如果有功能需求，可以后期开发。</div>' +
              '<div style="padding-bottom: 80px;">点击查看<a href="https://api.cloud.pkpm.cn/bimserver/translation/v3/convertertypes" target="_black">支持的文件转换类型</a></div>',
          },
          {
            id: '3',
            time: '2020-10-14 13:26:06',
            q: '格式转换中字段 job-type 中 xxxx-obv 和 xxxx-lod，是怎么转换？',
            a: 'xxxx 是您想转换的格式名称，obv 表示全量转换，lod 表示流式转换，推荐流式。点击了解<a href="../../../../devcenter/commonQuestion/#1-1&5" target="_black">全量和流式是什么意思</a>',
          },
          {
            id: '4',
            time: '2023-11-13 13:26:06',
            q: '为什么有些接口上传的文件，在控制台无法进行转换？',
            a: '控制台对转换文件的格式做了处理，格式为：文件名_格式，例如您这个文件是rvt格式，可以试试取名为test_rvt。',
          },
        ],
      },
      {
        name: 'oauth服务',
        id: '3',
        list: [
          {
            id: '1',
            time: '2020-10-16 16:22:26',
            q: 'ClientId 和 ClientSecret 在代码中一般放到哪里？',
            a:
              'ClientId 和 ClientSecret 一般会放到配置文件中，然后通过读取配置文件中的内容，读取到这两个值，调用接口生成 token。',
          },
          {
            id: '2',
            time: '2020-10-16 16:23:02',
            q: '如何查看 token 中的信息值？',
            a:
              '<div> token 是由 header，payload，signature 三部分通过字符 “.” 进行拼接组装而成（具体格式：header.payload.signature），最终形成了JWT。</div>' +
              '<div> 如果对 token 中的信息进行获取，需要通过base64进行解密，即将 token 中的 payload 部分放入解密网址：<a href="https://tool.oschina.net/encrypt?type=3" target="_blank">https://tool.oschina.net/encrypt?type=3</a>。</div>' +
              '<div style="color: #b1240c;padding-bottom: 80px;"> 注意：若想从 token 中获取 username 等值，可直接使用 utils 中自带的 base64 进行解密. </div>',
          },
          {
            id: '3',
            time: '2020-10-16 16:23:41',
            q: '如何从token中获取username等值？',
            a: '直接使用自带的utils中自带的base64进行解密',
          },
          {
            id: '4',
            time: '2020-10-16 16:23:41',
            q: '如果 token 报错，问题是否出在 2-legged、3-legged 上？',
            a:
              '<div style="width: 90%;padding-bottom: 80px;">三条腿的 OAuth（3-Legged OAuth），这也是 OAuth 的标准版本。这里所谓的“三条腿”，指的是授权过程中涉及前面提到的三种角色，也就是：客户端，服务提供方，用户。不过有些情况下，不需要用户的参与，此时就产生了一个变体，被称作两条腿的 OAuth（2-Legged OAuth），一般来说，访问私有数据的应用需要三条腿的OAuth，访问公共数据的应用需要两条腿的OAuth。两条腿的OAuth 和三条腿的OAuth 相比，因为没有用户的参与，所以在流程中就不会涉及用户授权的环节，也就不需要使用Token，而主要是通过 Consumer Key 和Consumer Secret 来完成签名的，此时的 Consumer Key 和 Consumer Secret 基本等价于账号和密码的作用。云平台对接是三条腿，BIMBase云平台（OBV） 对接是两条腿</div>',
          },
          {
            id: '5',
            time: '2020-05-21',
            q: '接口对接过程中header中是如何封装token的？',
            a:
              '<div>封装token一般是采用bearer +token 这种形式进行拼接的。</div>' +
              '<img src="../../../../static/img/commonQuestion/changeModel-token.png" style="width: 70%;padding-bottom: 80px;height: auto">',
          },
          {
            id: '6',
            time: '2020-05-21',
            q: '登录后返回页面是固定的，比如下载权限控制时登录后要返回当前页面，如何实现？',
            a: '登录有个state字段，可以存储当前页面状态，登录后可返回',
          },
          {
            id: '7',
            time: '2020-05-21',
            q: 'Token有效期的失效是多久？',
            a: 'token的失效时间默认是12小时，针对特定的clientId可以通过我们给您配置来进行失效时间的修改；',
          },
          {
            id: '8',
            time: '2020-05-21',
            q:
              '不同端的登录token值是不同的，是依据什么去区分假如我只有一套client_id 和 client_secret，我在产品不同端登录，是不是会冲掉web网站登录产生的token令牌？',
            a: '不会的，不同端登录是不同的session会话，生成的token是不同的.',
          },
        ],
      },
      {
        name: 'storage服务',
        id: '4',
        list: [
          {
            id: '1',
            time: '2021-07-09 16:45:48',
            q: '有删除Bucket的接口吗？',
            a:
              '目前没有对外提供删除Bucket的接口。您可以考虑在数据库中多加一个字段进行筛选，以达到假删除的效果。',
          },
          {
            id: '2',
            time: '2021-07-09 16:45:48',
            q: '为什么删除指定的Object接口突然不能用了？',
            a:
              '可能是objectKey含有空格、非法字符等问题造成的，建议用base64加密objectKey后再试一下。用base64加密objectKey时，需要在接口后面拼接参数objectKeyEncoding=base64。' +
              '<div style="padding-bottom: 80px;">API文档：<a href="../../../../devcenter/help/server-api/docs/Storage/#7bucketobject" target="_black">https://cloud.pkpm.cn/devcenter/help/server-api/docs/Storage/#7bucketobject</a></div>',
          },
        ],
      },
      {
        name: '用户模块',
        id: '5',
        list: [
          {
            id: '1',
            time: '2020-05-21',
            q: '批量修改用户信息，比如用户密码，是否会短信告知用户？',
            a:
              '批量短信通知用户或者邮箱方式都是可以选择的，如果希望尽量不要给用户造成不好的体验，也可以自己设定密码，不会通知用户。',
          },
        ],
      },
      {
        name: '基本概念',
        id: '6',
        list: [
          {
            id: '1',
            time: '2020-05-21',
            q: '批注接口中commentId这个字段要怎么填写？',
            a:
              'commentid是需要用户去自定义的字段，作用只是为了将批注文本和模型进行关联，用户可以通过创建关联表通过commentid进行关联。',
          },
        ],
      },
    ],
  },
  {
    name: '接口服务',
    id: '6',
    children: [
      {
        name: '基础API',
        id: '1',
        list: [
          {
            id: '1',
            time: '2021-07-09 16:45:48',
            q: '模型上可以模拟人的运动轨迹吗？',
            a:
              '可以的，每个人都以外部构件的方式放到模型里面，实时的更新这些外部构件的位置信息，就可以做到这个效果。',
          },
          {
            id: '2',
            time: '2021-07-09 16:45:48',
            q: '外部构件数量有限制吗？',
            a: '外部构件数量的话 不要太多，百级的单位是没有问题的。',
          },
          {
            id: '3',
            time: '2021-07-09 16:45:48',
            q: '如何将外部构件通过三维视图可视化的方式呈现给用户？',
            a:
              '使用ObvApi.createExternalScene()这个接口创建外部场景，通过three.js设置外部构件颜色、形状大小、以及相对模型中心点的坐标position、再通过ObvApi.addExternalObjects()将多个立方体添加到外部场景中。' +
              '<div style="padding-bottom: 80px;">API文档：<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/#_14" target="_black">https://cloud.pkpm.cn/devcenter/help/js-api/docs/demo-api/docs/demo-api/#_14</a>' +
              '<br/>' +
              '外部场景demo示例：<a href="../../../../playground/lod/?sampleID=externalSceneAPI" target="_black">https://cloud.pkpm.cn/playground/lod/?sampleID=externalSceneAPI</a></div>',
          },
        ],
      },
    ],
  },
  {
    name: '数据引入',
    id: '7',
    children: [
      {
        name: '显卡设置',
        id: '1',
        list: [
          {
            id: '1',
            time: '2020-10-16 16:23:41',
            q: '电脑打开模型，屏幕闪动，模型变得粗糙，如何锁定浏览模型保证使用独立显卡打开？',
            a:
              '<div>Microsoft在Windows 10（2004版本）变更了图形处理器选取设置的优先权，部分应用在Windows图形效能喜好设置的优先权将会高于显示适配器硬件厂商的控制面板（如NVIDIA控制面板及AMD Radeon Software）中的首选设置。例如，您在NVIDIA控制面板中将某个应用设置使用NVIDIA显示适配器作为首选图形处理器，但Windows预设设置为使用内建显示适配器，此应用将会依据Windows的设置而使用内建显示适配器作为首选的图形处理器。</div>' +
              '<div style="color: #b1240c"> > 注意：Microsoft可能会实时通过后台新增应用行表至Windows并套用默认的图形处理器，如果您要变更某个应用的图形显示器选取设置，建议您在Windows设置及显示适配器硬件厂商的控制面板都要同步设置。</div>' +
              '<div style="font-weight: bold">如何设置应用在Windows OS的首选图形处理器</div>' +
              '<div style="padding-left: 20px"> a. 在Windows搜寻栏输入【图形设置】，然后点选【打开】。</div>' +
              '<img src="../../../../static/img/commonQuestion/001.png" style="padding-left:20px;width: 50%;height: auto">' +
              '<div style="padding-left: 20px"> b. 在图形性能首选项中，您可以从下拉式选单中点选【经典应用】，点击【浏览】来选取应用；选取或浏览新增应用后，将会出现在下列，然后点选【选项】。</div>' +
              '<img src="../../../../static/img/commonQuestion/002.png" style="padding-left:20px;width: 50%;height: auto">' +
              '<div style="padding-left: 20px"> c. 选取您要设置的图形处理器，然后点选【保存】。</div>' +
              '<img src="../../../../static/img/commonQuestion/003.png" style="padding-left:20px;width: 50%;height: auto">' +
              '<div style="padding-left: 20px"> d. 应用已设置为您偏好的图形处理器。</div>' +
              '<img src="../../../../static/img/commonQuestion/004.png" style="padding-left:20px;padding-bottom: 80px;width: 50%;height: auto">',
          },
          // {
          //     id: '2',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      {
        name: '配置文件',
        id: '2',
        list: [
          {
            id: '1',
            time: '2020-05-21',
            q:
              '提供SDK的方式是什么，是提供js的网址直接引用吗？或者直接将obv.js文件从服务器上下载下来？有没有其他相关文件？',
            a:
              '我们使用SDK的方式是直接引用，不需要从服务器上下载，分别需要引入三个文件；因为我们在更新一些新功能或者修改bug后发布，用户通过这种方式引入BIMBase云平台（OBV），新增功能刷新界面就可以直接使用了，做成包的话每次都要重新打包替换，操作起来会有一些繁琐。',
          },
        ],
      },
      // {
      //     name: '',
      //     id: '2',
      //     list: [
      //         {
      //             id: '1',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '2',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '3',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //     ],
      // },
      // {
      //     name: '',
      //     id: '3',
      //     list: [
      //         {
      //             id: '1',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '2',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '3',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //     ],
      // },
    ],
  },
  {
    name: 'OBMXSDK',
    id: '8',
    children: [
      {
        name: '贴图流程',
        id: '1',
        list: [
          {
            id: '1',
            time: '2020-12-25 13:12:45',
            q: '使用obmxsdk来设置贴图需要进行哪些流程？有哪些注意事项？',
            a:
              '<div style="font-size: 1.3rem;font-weight: 600">1.1.材质相关</div>' +
              '<div style="padding-left: 20px">1.初始化材质包</div>' +
              '<div style="padding-left: 40px">OBMMaterial *material = OBMMaterial::create();</div>' +
              '<div style="padding-left: 20px">2.材质包设置唯一ID，在场景树中与相应的Mesh/Geometry关联起来</div>' +
              '<div style="padding-left: 40px">material->setName(materialId);</div>' +
              '<div style="padding-left: 20px">3.设置漫反射光</div>' +
              '<div style="padding-left: 40px">material->setTextureColor(OBMMaterial::TexType::Diffuse, OBMColor(1.0f,1.0f,1.0f,1.0f));&nbsp;&nbsp;<p style="display:inline;color: green">//示例数据，RGBA格式，若有除diffuse外的颜色，可修改该类型</p></div>' +
              '<div style="padding-left: 20px">4.设置贴图</div>' +
              '<div style="padding-left: 40px">material->setTextureName(OBMMaterial::TexType::Diffuse, textName);&nbsp;&nbsp;<p style="display:inline;color: green">//类型为diffuse，若有除diffuse外的贴图，可修改该类型，textName必须为文件名（带后缀），下同。</p></div>' +
              '<div style="padding-left: 40px">obm3dPackage.addTexture(textName, diffuseFileSource);&nbsp;&nbsp;<p style="display:inline;color: green">//textName必须为文件名（带后缀），支持常见的贴图文件格式</p></div>' +
              '<div style="padding-left: 20px">5.设置transform</div>' +
              '<div style="padding-left: 40px">material.setTextureTransform(OBMMaterial::TexType::Diffuse, float uScale, float vScale, float uOffset, float vOffset, float wAngle);</div>' +
              '<div style="padding-left: 20px">6.添加到Obmx3d包</div>' +
              '<div style="padding-left: 40px">obm3dPackage.addMaterial(material);</div>' +
              '<div style="padding-top: 10px;font-size: 1.3rem;font-weight: 600">1.2.几何面片相关</div>' +
              '<div style="padding-left: 20px">1.创建mesh</div>' +
              '<div style="padding-left: 40px">OBMTriangleMesh *mesh = OBMTriangleMesh::create();</div>' +
              '<div style="padding-left: 20px">2.设置ID</div>' +
              '<div style="padding-left: 40px">mesh->setGeometryId(meshId);</div>' +
              '<div style="padding-left: 20px">3.添加到Obmx3d包</div>' +
              '<div style="padding-left: 40px">obm3dPackage.addMesh(mesh);</div>' +
              '<div style="padding-top: 10px;font-size: 1.3rem;font-weight: 600">1.3.场景树相关</div>' +
              '<div style="padding-left: 20px">1.创建场景树节点</div>' +
              '<div style="padding-left: 40px">OBMInstanceTreeNode *insNodeChild = insNode->createChildNode();</div>' +
              '<div style="padding-left: 20px">2.设置类型</div>' +
              '<div style="padding-left: 40px">insNodeChild->setType(OBMInstanceTreeNode::NT_Geometry);</div>' +
              '<div style="padding-left: 20px">3.设置关联的模型树ID</div>' +
              '<div style="padding-left: 40px">insNodeChild->setDatabaseId(dbId);</div>' +
              '<div style="padding-left: 20px">4.设置几何面片ID</div>' +
              '<div style="padding-left: 40px">insNodeChild->setGeometryIdmeshId);</div>' +
              '<div style="padding-left: 20px">5.设置材质ID</div>' +
              '<div style="padding-left: 40px;padding-bottom: 80px">insNodeChild→setMaterialId(materialId);</div>',
          },
        ],
      },
      {
        name: '矩阵说明',
        id: '2',
        list: [
          {
            id: '1',
            time: '2021-08-10',
            q: ' 对于OBMXSDK接口中地转换矩阵有没有详细的格式说明？',
            a:
              '<div style="font-size: 1.3rem">接口说明（以获取为例，对应的设置接口类似）</div>' +
              '<div style="font-size: 1.3rem">1.创建transform</div>' +
              '<div style="padding-left: 20px">接口：static OBMAffineTransform *create(float m00, float m01, float m02, float m10, float m11, float m12, float m20, float m21, float m22, double t1, double t2, double t3);</div>' +
              '<div style="padding-left: 20px">参数示意：</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-1.png" style="padding-left:60px;width: 35%;height: auto">' +
              '<div style="font-size: 1.3rem">2.获取参数</div>' +
              '<div style="padding-left: 20px">接口：void getValues(float &s00, float &s01, float &s02, float &s10, float &s11, float &s12, float &s20, float &s21, float &s22, double &t1, double &t2, double &t3) const;</div>' +
              '<div style="padding-left: 20px">参数示意：</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-2.png" style="padding-left:60px;width: 35%;height: auto">' +
              '<div style="padding-left: 20px">接口：const float* getValues() const;</div>' +
              '<div style="padding-left: 20px">参数示意：</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-3.png" style="padding-left:60px;padding-bottom: 80px;width: 35%;height: auto">',
          },
        ],
      },
      {
        name: '实例化',
        id: '3',
        list: [
          {
            id: '1',
            time: '2021-08-10',
            q: '想进行几何复用以减少mesh的数量，思路是怎么样的呢？有什么注意事项？',
            a:
              '<div style="padding-left: 20px">几何一致的构件，也可称为实例化构件（如模型中的多棵外观一致的树、盆景或门窗等构件）几何外观是一致的，而位置不一致，这样就可以用{一组几何数据}+{各自的位置转换矩阵}来描述这些实例化的构件，可以有效的共享复用几何数据，从而减少几何数据量。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-instantiate-1.png" style="padding-left:60px;width: 35%;height: auto">' +
              '<div style="padding-left: 20px">注意：</div>' +
              '<div style="padding-left: 20px">1.pmodel格式中实例化的mesh要求几何和对应的材质都一致，才可作为实例化mesh</div>' +
              '<div style="padding-left: 20px">2.几何外观一致，位置不一致的描述也适用于镜像、缩放改变的构件，如一棵大树和相对于其缩小的一棵小树</div>' +
              '<div style="padding-left: 20px">3.如果存在大量的实例化mesh只被共享复用很少次数（如大量的实例化mesh只被引用了2~3次）可能对数据组织优化有反作用，可能会降低渲染效率，因此对于比如模型中的楼板构件，可能不需要做实例化处理。</div>',
          },
        ],
      },
    ],
  },
  {
    name: '转换器',
    id: '9',
    children: [
      {
        name: '服务概述',
        id: '1',
        list: [
          {
            id: '1',
            time: '2022-04-19',
            q: 'BIMBase云平台/图模大师都支持哪些格式的轻量化？',
            a:
              '<div>BIMBase云平台/图模大师支持几十种格式的转换，以轻量化转换服务的方式（用户可直接上传文件）和安装使用图模大师插件（自行导出pmodel文件后上传）两种方式提供支持。</div>' +
              '<div style="padding-top: 5px; font-weight: bolder">（一）轻量化转换服务的方式支持的格式如下：</div>' +
              '<div style="padding-left: 20px"> 3dm,p3d,bfa,gim,docx,dri,dwf,dwfx,dwg,fbx,gltf,glb,htm,html,3ds,ifc,iges,igs,imodel,ipt,iam,jt,ms3d,nwc,nwd,obj,pdf,ppt,pptx,prj,rcp,CATPart,rfa,rte,rvm,rvt,sat,skp,sldprt,step,stl,dxf,txt,wrl,wrz,x3d,xgl,xls,xlsx,xml,tiff,csv,xps,mpt,vsd,oxps,jpg,jpeg,bmp,dae,png,gif,xdb,obmx,pmodel,dgn,doc,jws,bdls,stp,vue,att,json；</div>' +
              '<div style="padding-left: 10px; font-weight: bolder">其中当前重点支持的格式及支持的版本(优先级顺序) : </div>' +
              '<img src="../../../../static/img/commonQuestion/support-format.png" style="padding-left:60px;width: 40%;height: auto">' +
              '<div style="padding-left: 30px">其它格式为非重点支持格式。当前支持格式主要分为BIM格式、矢量/图档格式、点云格式{目前不支持，比如RES. LAS. XZ等)</div>' +
              '<div style="padding-left: 10px; font-weight: bolder">（二）安装使用图模大师插件支持对应客户端软件所能打开的格式：</div>' +
              '<div style="padding-left: 30px">如Revit软件可以打开rvt、rfa、adsk、rte等格式，还可以打开Revit兼容的格式如IFC（当然如果要轻量化IFC格式不需要通过Revit打开这种途径，因为有更方便和快速的方式：直接上传IFC格式即可）；</div>' +
              '<div style="padding-left: 30px;padding-bottom: 80px;">Archicad软件可以打开pln、pla、bpn等丰富的格式，当然其中有些格式有更方便快捷的途径转换，就是上传文件即可；</div>'
          },
          {
            id: '2',
            time: '2022-04-19',
            q: '图模大师支持的轻量化格式与哪些软件对应？',
            a:
              '<img src="../../../../static/img/commonQuestion/transverter-1.png" style="padding-left:60px;width: 75%;height: auto">',
          },
          {
            id: '3',
            time: '2020-12-25 16:48:13',
            q: '可以通过哪些途径使用图模大师提供的轻量化服务？',
            a:
              '<div>1. 可以直接上传支持格式的文件，图模大师的服务器上运行有丰富的转换器来处理支持这种转换功能；</div>' +
              '<div style="padding-bottom: 80px;">2. 我们还发布有<a href="https://product.pkpm.cn/downloadlist?pId=3" target="_blank">多款插件</a>，用户可以下载安装，以便在自己的机器上将模型导出为 pmodel/obmx 格式，这些插件可以在官网下载。</div>',
          },
          // {
          //     id: '3',
          //     time: '',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      {
        name: '轻量化插件',
        id: '2',
        list: [
          {
            id: '1',
            time: '2021-07-09 16:45:48',
            q: '图模大师发布有哪些插件？在哪里可以获取到？',
            a:
              '<div> 图模大师目前已发布有8款插件（如下表），用户可以在 <a href="https://www.pkpm.cn/product/downloadAll?type=5" target="_blank">PKPM官网</a> 获取插件列表并进行插件下载；</div>' +
              '<div> 另外还有一些插件在开发中，如Rhino插件，后续会发布更多实用的轻量化插件。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-rvt-1.png" style="padding-left:30px;padding-bottom: 80px;width: 70%;height: auto">',
          },
          {
            id: '2',
            time: '2021-01-05 11:12:08',
            q: '安装图模大师插件都有什么注意事项？',
            a:
              '<div> 安装插件前要关掉相应软件，然后再安装，比如要关掉所有的Revit软件，然后再安装图模大师Revit插件；</div>' +
              '<div> 在安装Archicad插件的过程中，请注意按提示 “请选择Archicad.exe所在文件夹的上级文件夹！” 选择安装目录，否则会有不能正常使用的问题。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-rvt-2.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 45%;height: auto">' +
              '<div> PDMS插件和3ds Max插件在安装时，安装程序首先会自动查找PDMS或3ds Max的安装目录，在查找不到时需要用户手动选择正确的PDMS或3ds Max的安装目录。</div>' +
              '<div style="color: #b1240c">注意：用户不能随意选择插件的安装位置。</div>',
          },
          {
            id: '3',
            time: '2021-01-05 11:12:28',
            q: '图模大师的合模功能很好用，但合模时候发现有些模型位置不对，是什么原因？',
            a:
              '用户可以使用图模大师的合模功能将多个 pmodel模型 整合到一起，目前 Revit插件 导出来的 pmodel文件 是共享坐标系下的模型，如果用户想在图模大师中对多个来源 Revit 的模型进行合模，那么需要确认这几个模型 Revit 中采用共享坐标进行链接后位置也是能够正确拼装的，如果不能，就需要用户按以下教程来调整 Revit模型，<a href="https://knowledge.autodesk.com/zh-hans/support/revit-products/learn-explore/caas/sfdcarticles/sfdcarticles/CHS/How-to-coordinate-new-model-into-existing-shared-coordinates.html" target="_blank">如何将新模型调整至现有共享坐标</a> ，然后再 导出pmodel 并使用图模大师的合模功能。',
          },
          {
            id: '4',
            time: '2023-11-13 11:12:32',
            q: '合模偏移量的计算规则是什么？',
            a:
              '不同设计软件有不同的坐标系设置方式，revit模型采用项目基点，dgn与ifc是在指定坐标系下的真实坐标位置进行建模。为保证合模时各模型相对位置的正确性，首先要保证项目使用的模型在建模时均在同一个指定坐标系下，例如revit设置的项目基点与dgn模型坐标值都是在同一个投影坐标系下的数据；在此前提下合模时可获取第一个加载模型的基点信息作为合模基准点，后续加载的模型使用基点信息减去第一个模型的基点信息计算相对偏移量并调用接口更新模型，通过上述计算可以得到正确的合模效果。',
          },
          {
            id: '5',
            time: '2023-11-13 11:24:11',
            q: '为什么dgn模型合模全堆积在一块了？',
            a: 'dgn模型是在指定坐标系下的真实坐标位置进行建模，坐标数据一般非常大，为保证轻量化模型数据精确性，在数据转换时将模型的包围盒中心点作为基点信息进行了保存，轻量化几何数据均是相对于基点位置的相对坐标，所以如果不计算合模偏离量，多个dgn模型就会堆积在一起，解决方法是获取第一个加载模型的基点信息作为合模基准点，后续加载的模型使用基点信息减去第一个模型的基点信息计算相对偏移量并调用接口更新模型，通过上述计算可以得到正确的合模效果。',
          },
          {
            id: '6',
            time: '2021-01-05 11:12:32',
            q: '使用Archicad插件时有什么注意事项？',
            a:
              '<div>使用 Archicad插件 进行 pmodel文件 导出时，请根据需要来选择导出的属性，因为 Archicad 的内置属性量特别大（其中很多都是软件相关的用户看不懂的属性），并且获取时间相对来说很长，不是特别需要就不要勾选属性(内置)复选框，如果您有定制导出属性方面的需求，欢迎和我们联系。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-rvt-3.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 80%;height: auto">',
          },
          {
            id: '7',
            time: '2021-01-05 11:24:11',
            q: '使用PDMS插件时有什么注意事项？',
            a: 'PDMS模型的属性数据量较大，导出较为耗时。',
          },
          {
            id: '8',
            time: '2021-03-02 11:28:09',
            q: 'Tekla插件支持导出的数据有哪些？',
            a:
              '<div> 1.模型：支持导出整个模型、模型树、构件属性、矩形轴网、螺栓、洞口；</div>' +
              '<div style="padding-bottom: 80px;"> 2.图纸：支持导出所有类型的图纸，暂不支持外部文档。</div>',
          },
          // {
          //     id: '7',
          //     time: '2021-01-05 11:28:09',
          //     q: '',
          //     a: '',
          // },
        ],
      },
      {
        name: '轻量化转换服务',
        id: '3',
        list: [
          {
            id: '1',
            time: '2021-01-05 11:28:09',
            q: '上传rvt格式的文件时有哪些注意事项？',
            a:
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-rvt-4.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 50%;height: auto">',
          },
          {
            id: '2',
            time: '2021-01-05 11:21:36',
            q: '上传rvt格式的文件转换完成后构件出现破面的现象？',
            a:
              '<div>在本地打开该rvt文件，检查项目基点的各个值是否合理，值过大时会出现破面的情况，如果值不合理将其改为0，重新上传转换就没有问题了。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-rvt-5.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 30%;height: auto">',
          },
          {
            id: '3',
            time: '2021-01-05 12:15:08',
            q: 'OBMSDK里可设置哪些单位？',
            a:
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-4.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 50%;height: auto">',
          },
          {
            id: '4',
            time: '2021-01-05 12:32:30',
            q: 'Tekla导出IFC文件后再上传到BIMBase云平台（OBV），显示的属性名不是中文怎么办？',
            a:
              '<div style="font-weight: bold;font-size: 1.2rem">解决办法</a></div>' +
              '<div style="padding-left: 20px">使用“属性集定义”工具创建新的属性集，参考Tekla 2018版本的<a href="https://teklastructures.support.tekla.com/zh-hans/2018/zh-hans/int_defining_property_sets_using_property_set_definitions" target="_blank">官方说明</a>，如找不到对应按钮，请选择对应的版本说明。</div>' +
              '<div style="padding-left: 30px">1. 在【文件】菜单上，单击【输出 > IFC】。</div>' +
              '<div style="padding-left: 30px">2. 在【附加属性设置】列表中选择【<新>】，然后单击【编辑】（如果您已复制模型文件夹中的预定义配置文件之一，请打开该文件）。</div>' +
              '<div style="padding-left: 30px">3. 对于新配置文件，请在【属性设置定义】对话框中，在【名称】框中为该配置文件输入名称。</div>' +
              '<div style="padding-left: 30px">4. 在【新建】按钮旁输入属性设置的名称，然后单击【新建】。</div>' +
              '<div style="padding-left: 45px">a. 可以在【属性设置】列表中选择属性设置之一。</div>' +
              '<div style="padding-left: 45px">b. 如果想在一个配置文件中创建多个属性设置（您可以添加 COG、零件层次的起点和终点以及构件层次的预定信息）。</div>' +
              '<div style="padding-left: 30px">5. 对于新的属性设置，在空框中为属性设置输入描述。</div>' +
              '<div style="padding-left: 30px">6. 通过在【选择实体类型】列表中，选中某一实体类型的复选框，来选择该实体类型。</div>' +
              '<div style="padding-left: 45px;color: red">注意：在执行此操作时，【选择属性】列表会显示可供所选实体类型使用的属性。</div>' +
              '<div style="padding-left: 30px">7. 选中属性名称旁边的复选框，从【选择属性】列表添加所需属性，该属性将添加到右侧的【所有选定属性的列表】列表中。</div>' +
              '<div style="padding-left: 45px">此列表显示所输出的属性及其格式：</div>' +
              '<div style="padding-left: 60px">a. 您可以通过在【创建/修改属性】区域的【属性】框中输出属性名称并单击【添加】按钮来添加新的属性。</div>' +
              '<div style="padding-left: 60px">b. 可以通过在列表中选择属性并单击【修改】或【删除】来修改和删除列表中的属性。</div>' +
              '<div style="padding-left: 30px">8. 在【创建/修改属性】下面，定义属性特性。</div>' +
              '<div style="padding-left: 45px">步骤：</div>' +
              '<div style="padding-left: 60px">a. 为所选属性选择【属性类型】，在此处，始终为名称中包含的字符数超过 19 个的用户定义的属性选择【模板属性】。</div>' +
              '<div style="padding-left: 75px">例如，为 ASSEMBLY.USERDEFINED.PLANS_STATUS 选择【模板属性】。</div>' +
              '<div style="padding-left: 60px">b. 在名称框【名称】中输入或修改所选属性的名称。</div>' +
              '<div style="padding-left: 60px">c. 选择属性的【类型】，此处的【类型】可以为以下值之一： 字符串（字符序列）、 布尔（false 或 true）、 整数（没有小数部分的数字）、 测量 、 实数[型]（使用十进制表示法的数字）或 时间戳。</div>' +
              '<div style="padding-left: 60px">d. 如果用户定义的属性的类型为【测量】：</div>' +
              '<div style="padding-left: 75px">① 您可以选择【测量类型】： 长度 、 面积 、 体积 、 质量 、 正长度 或 数量。</div>' +
              '<div style="padding-left: 75px">② 您可以选择【转换】系数和【精度】。</div>' +
              '<div style="padding-left: 75px">③ 用户可定义的精度可以实现更好的 IFC 文件大小优化。</div>' +
              '<div style="padding-left: 30px;padding-bottom: 20px">9. 单击【保存】以保存所做的修改。</div>' +
              '<div style="font-weight: bold;font-size: 1.2rem">下面是 属性设置定义 对话框内容的示例</div>' +
              '<div style="padding-left: 30px">1. 按上述流程打开面板进行设置。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-5.png" style="padding-left: 45px;padding-top: 10px;width: 50%;height: auto">' +
              '<div style="padding-left: 30px">2. 导出IFC后，选择刚刚新建的配置文件，再点击输出。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-6.png" style="padding-left: 45px;padding-top: 10px;width: 50%;height: auto">' +
              '<div style="padding-left: 30px">3. 在BIMBase云平台（OBV）中修改前后对比。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-7.png" style="padding-left: 45px;padding-top: 10px;width: 50%;height: auto">' +
              '<div style="padding-left: 30px">4. 属性定义对话框说明。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-transform-8.png" style="padding-left: 45px;padding-top: 10px;width: 50%;height: auto">' +
              '<div style="padding-left: 50px">a. 实体组中，Tekla Structures 属性写入到输出的 IFC 文件中。</div>' +
              '<div style="padding-left: 50px">b. 要为所选实体输出的模板属性或用户定义的属性。</div>' +
              '<div style="padding-left: 50px">c. 显示所选属性的列表。</div>' +
              '<div style="padding-left: 50px">d. 您可以为属性定义的特性。</div>' +
              '<div style="padding-bottom: 80px"></div>',
          },
          {
            id: '5',
            time: '2021-03-09 15:18:34',
            q: '使用revit插件导出二维图纸，有字体标注乱码和线条颜色变化问题，应该如何解决？',
            a:
              '<div style="padding-left: 20px"> revit插件导二维图纸的原理：rvt -> dwg -> obmx，其中 rvt -> dwg 的过程是由revit插件执行。</div>' +
              '<div style="padding-left: 20px"> 根据相关搜索，是revit插件导出dwg图纸出现问题，导出的二维图纸使用Autodesk CAD查看仍然有字体标注乱码和线条颜色变化问题，需要等待revit修复。</div>' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-revit-2.png" style="padding-left: 30px;padding-top: 10px;width: 50%;height: auto">' +
              '<img src="../../../../static/img/commonQuestion/OBMXSDK-revit-1.png" style="padding-left: 30px;padding-top: 10px;padding-bottom: 80px;width: 80%;height: auto">',
          },
          {
            id: '6',
            time: '2021-05-21',
            q: '天正CAD导出的dwg上传后由元素丢失，该怎么处理？',
            a:
              '天正dwg不是标准格式的dwg，需要在天正软件中导出普通格式的dwg（t3），<a href= "https://www.sohu.com/a/128019687_612933" target="_blank">具体参考</a>',
          },
          {
            id: '7',
            time: '2021-05-21',
            q: '三维dwg怎么处理？',
            a:
              '<div style="padding-left: 20px"> 我们预计2021年7月15日后会发布一版CAD插件，可以直接导出pmodel；另外现在可以用autoCad或者navisworks软件将三维dwg导出为dwf，直接上传dwf，也可以使用图模大师navisworks插件导出pmodel。</div>' +
              '<img src="../../../../static/img/commonQuestion/dwgSetting1.png" style="padding-left: 30px;padding-top: 10px;width:70%;height: auto">' +
              '<img src="../../../../static/img/commonQuestion/dwgSetting2.png" style="padding-left: 30px;padding-top: 10px;width:70%;padding-bottom: 80px;height: auto">',
          },
          {
            id: '8',
            time: '2024-04-02',
            q: 'BIMBase云平台（OBV）可以将pmodel导出其他格式吗？',
            a:
              '不像轻量化转换功能接口那么丰富，对于pmodel格式转为其他格式，目前已支持的有将pmodel转为gltf、udb（超图GIS格式）、bims，正在开发中的有pmodel转obj；ptiles可以转fbx、ifc、gim；',
          },
          {
            id: '9',
            time: '2021-05-21',
            q: '都支持哪些版本的imodel格式？',
            a:
              '<div style="padding-left: 20px">支持imodel1.6及以下版本，目前不支持高版本，但同时支持.i.dgn格式。</div>' +
              '<div style="padding-left: 20px">一般来说发布imodel格式都同时支持分发部.imodel和.i.dgn（一个是移动端 一个是桌面端），所以可以发布.i.dgn以进行轻量化（使用Microstation插件方式或直接上传）。</div>',
          },
          {
            id: '10',
            time: '2021-05-21',
            q: '哪些格式轻量化后可以进行二三维联动？通过什么方式？',
            a:
              '<div style="padding-left: 20px">二三维联动功能可以实时的在模型的二维dwg和三维模型中进行构件级联动，方便用户进行浏览查看信息。</div>' +
              '<div style="padding-left: 20px">目前可以通过<span style="font-weight:bold">图模大师Revit插件</span>导出pmodel、<span style="font-weight:bold">图模大师Tekla插件</span>导出pmodel、<span style="font-weight:bold">PBIM铝模板软件客户端</span>导出pmodel方式进行二三维数据的导出及在图模大师上进行二三维联动功能。</div>' +
              '<div style="padding-left: 20px">理论上只要二维dwg和三维模型存在一定格式的关联（具体格式由BIMBase云平台团队制定和维护），就可以使用图模大师的二三维联动功能，详情请联系技术支持。</div>',
          },
          {
            id: '11',
            time: '2022-11-1',
            q: 'Navisworks轻量化插件导出的模型存在几何错乱，或构件位置不准确的问题是什么原因？如何解决？',
            a:
              '<div style="padding-left: 20px">在使用navisworks插件导出时可能会出现如下现象：</div>' +
              '<div style="padding-left: 20px">（1）几何错乱：<img src="../../../../static/img/commonQuestion/transform-11-1.png" style="padding-left: 30px;padding-top: 10px;width: 35%;height: 35%"></div>' +
              '<div style="padding-left: 20px">（2）构件位置有细微偏移：<img src="../../../../static/img/commonQuestion/transform-11-2.png" style="padding-left: 30px;padding-top: 10px;width: 35%;height: 35%"></div>' +
              '<div style="padding-left: 20px">以上现象可能是由于模型的原点位置设置过大引起的，如以上示例，模型的原点坐标达到(830408.43, 831310.17, 0)。这样大的原点坐标导致模型整体的坐标都非常大，然而浮点型数据储存的有效位数有限，这样大的坐标非常容易引起模型精度不够的问题。</div>' +
              '<div style="padding-left: 20px">解决方案：</div>' +
              '<div style="padding-left: 20px">1、在navisworks软件中点击常用->模型树->右击根节点->选择单位和变换</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/transform-11-3.png" style="padding-left: 30px;padding-top: 10px;width: 40%;height: 40%"></div>' +
              '<div style="padding-left: 20px">2、在弹出的窗口中修改原点坐标</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/transform-11-4.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>' +
              '<div style="padding-left: 20px">3、再次尝试导出。</div>' +
              '<div style="padding-left: 20px">若以上方法未能解决您的问题，请与我们联系。</div>',
          },
          {
            id: '12',
            time: '2023-11-13',
            q: '文件上传转换后，查看时有时存在构件丢失情况，可能的原因有哪些？',
            a:
              '<div style="padding-left: 20px">1、原模型是链接模型：建筑信息模型通常由多个链接模型组成，每个链接模型描述了不同的建筑方面，如结构模型、机电模型、管道模型等。这些链接模型可以相互关联，建立一个完整的建筑信息模型。BIMBase云平台不支持链接模型轻量化，若原模型为链接模型，无法显示。</div>' +
              '<div style="padding-left: 20px">2、在建模软件建立模型时，有时会设置剖切框，剖切框外的构件无法导出，取消剖切框选项即可。下图以REVIT 2020软件为例：</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/cancel-cutting-box.png" style="padding-left: 30px;padding-top: 10px;width: 35%;height: 35%"></div>' +
              '<div style="padding-left: 20px">3、轻量化解析问题，可联系相关对接人反馈问题。</div>'
          },
          {
            id: '13',
            time: '2024-09-09',
            q: '由3dsMax插件导出的pmodel文件转换后构件飞出该怎么处理？',
            a:
              '<div style="padding-left: 20px">如图，从模型树观察到屋顶构件存在但位置不对：</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/3ds-component-flies-out-1.jpg" style="padding-left: 30px;padding-top: 10px;width: 80%;height: 35%"></div>' +
              '<div style="padding-left: 20px">1、位置不对的原因是该构件绑定了贴图缩放绑定器，在修改器列表中右键将该贴图缩放绑定器组件删去。</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/3ds-component-flies-out-2.jpg" style="padding-left: 30px;padding-top: 10px;width: 80%;height: 35%"></div>' +
              '<div style="padding-left: 20px">2、选中“挤出”，再把“生成贴图坐标”勾选上。再重新用插件导出一次，观察屋顶构件是否恢复正常。</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/3ds-component-flies-out-3.jpg" style="padding-left: 30px;padding-top: 10px;width: 35%;height: 35%"></div>' +
              '<div style="padding-left: 20px">重新导出后屋顶恢复正常：</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/3ds-component-flies-out-4.jpg" style="padding-left: 30px;padding-top: 10px;width: 80%;height: 35%"></div>'
          },
          {
            id: '14',
            time: '2024-06-30',
            q: '由3dsMax导出的fbx文件转换后构件材质显示为标准颜色材质，丢失了贴图，该怎么处理？',
            a:
              '<div style="padding-left: 20px">1、丢失贴图可能是在使用3dsMax导出时导出了其他程序不支持的贴图，会有以下警告</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/export-map-error.png" style="padding-left: 30px;padding-top: 10px;width: auto;"></div>' +
              '<div style="padding-left: 20px">2、提供一种简单的解决方法</div>' +
              '<div style="padding-left: 40px">a、根据导出时提示的警告信息，在材质编辑器中找到相应的异常贴图，选中单击右键，点击渲染贴图。</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/map-setting-1.png" style="padding-left: 30px;padding-top: 10px;width: auto;"></div>' +
              '<div style="padding-left: 40px">b、点击”输出“栏文件（或直接点击渲染，稍后手动保存也可），在确认好文件保存位置后会弹出BMP配置，选择8位优化调色板（保持原色彩，24位会有色差），点击确定，将图片保存到指定位置。</div>' +
              '<div style="padding-left: 40px"><img src="../../../../static/img/commonQuestion/map-setting-2.png" style="padding-left: 30px;padding-top: 10px;width: auto;"></div>' +
              '<div style="padding-left: 40px"><img src="../../../../static/img/commonQuestion/map-setting-3.png" style="padding-left: 30px;padding-top: 10px;width: auto;"></div>' +
              '<div style="padding-left: 40px">c、将原贴图删除，重新添加刚才保存的位图，依次选择 贴图->通用->位图，导入新的贴图后可以重新导出fbx文件，能够保证贴图颜色正确的同时不会有警告。</div>' +
              '<div style="padding-left: 40px"><img src="../../../../static/img/commonQuestion/map-setting-4.png" style="padding-left: 30px;padding-top: 10px;width: auto;"></div>'
          },
          {
            id: '15',
            time: '2024-09-09',
            q: 'rvt模型自定义贴图丢失了，该怎么处理呢？',
            a:
              '<div style="padding-left: 20px">不支持自定义贴图（因为本地贴图的文件无法和rvt一起上传转换），建议尝试下插件导出。安装图模大师Revit插件导出<a href="https://product.pkpm.cn/downloadList" target="_black">（产品及解决方案中心 (pkpm.cn)）</a>，导出文件是pmodel格式，再上传转换</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/rvt-plug-in.jpg" style="padding-left: 30px;padding-top: 10px;width: 80%;"></div>'
          },
        ],
      },
      // {
      //     name: '',
      //     id: '3',
      //     list: [
      //         {
      //             id: '1',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '2',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //         {
      //             id: '3',
      //             time: '',
      //             q: '',
      //             a: '',
      //         },
      //     ],
      // },
    ],
  },
  {
    name: 'pmodel检查工具',
    id: '10',
    children: [
      {
        name: '检查工具介绍',
        id: '1',
        list: [
          {
            id: '1',
            time: '2021-08-10',
            q: '作用和目的',
            a:
              '<div style="padding-left: 20px">PModel 全称为 PKPM Model，为构力轻量化数据文件，后缀名为.pmodel。PModel 包含建筑工程领域设计过程中的阶段性成果，包括三维模型、二维图纸和文档等信息。用户可以借助pmodel文件进行建筑设计的轻量化浏览，进而实现便捷的在线协同工作。然而随着pmodel文件的导出来源增多，相应存在的问题也逐渐增加，这类存在问题的pmodel文件会出现无法加载、加载效率低下、显示效果差等问题，严重影响工作效率，因此需要对pmodel文件中存在的问题加以排查。</div>' +
              '<div style="padding-left: 20px">在过去的工作中，对pmodel文件的问题排查往往是通过人工的方式进行，这种方式费时费力，且很难清晰准确地捕捉所有问题。因此，pmodel检查工具的主要作用就是对于pmodel文件中的一些常见多发问题进行检查，同时输出文件的关键信息，生成检查报告，辅助相关人员进行问题定位和文件改进。此外，检查工具的代码内部开源，需要解析读取pmodel文件的相关方可以参考复用代码，并且可以选择跟随更新或参与开发。</div>',
          },
          {
            id: '2',
            time: '2021-08-10',
            q: '主要检查项',
            a:
              '<div style="font-size: 1.3rem;margin-top: 10px;">检查工具将对pmodel文件进行全面检查，主要检查和输出项如下：</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">1. 文件基本信息</div>' +
              '<div style="padding-left: 20px">a.文件包版本</div>' +
              '<div style="padding-left: 20px">b.二维、三维视图数量</div>' +
              '<div style="padding-left: 20px">c.模型长度单位</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">2.相机信息</div>' +
              '<div style="padding-left: 20px">a.检查相机数据是否有效</div>' +
              '<div style="padding-left: 20px">b.检查相机与模型的相对位置，判断相机是否过近或过远\n</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">3.模型树</div>' +
              '<div style="padding-left: 20px">a.检查模型树的组织方式，计算模型树的节点数量和深度</div>' +
              '<div style="padding-left: 20px">b.检查是否存在dbid一致的节点，pmodel格式不允许模型树节点出现相同的dbid</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">4.构件信息</div>' +
              '<div style="padding-left: 20px">a.构件数量</div>' +
              '<div style="padding-left: 20px">b.通过检查场景树，判断构件是否缺失几何信息</div>' +
              '<div style="padding-left: 20px">c.构件位置检测，判断是否存在构件与主体模型偏离较远</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">5.几何信息</div>' +
              '<div style="padding-left: 20px">a.几何总数量</div>' +
              '<div style="padding-left: 20px">b.平均每个构件的几何数量，可判断构件的几何组织是否过于细碎</div>' +
              '<div style="padding-left: 20px">c.几何的共享情况：被共享的几何总数及未被共享的几何总数，被共享几何的平均共享次数、最大共享次数、中位数\n</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">6.顶点和三角面</div>' +
              '<div style="padding-left: 20px">a.检测顶点和三角面总数，初步判断是否进行了点合并</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">7.材质信息</div>' +
              '<div style="padding-left: 20px">a.检测几何是否缺失材料信息</div>' +
              '<div style="padding-left: 20px">b.检测某个构件中是否存在两个或多个几何不被共享但是材质相同的情况，若存在这种情况则认为这些几何可以进行合并，为可以改进的问题</div>' +
              '<div style="font-size: 1.3rem;margin-top: 10px;">8.构件属性信息检测</div>' +
              '<div style="padding-left: 20px">a.检测构件是否缺失属性</div>' +
              '<div style="padding-left: 20px">b.计算构件的平均属性数量</div>',
          },
          {
            id: '3',
            time: '2021-08-10',
            q: '使用流程及输出报告',
            a:
              '<div style="padding-left: 20px">以下图所示的模型的pmodel文件为例进行使用流程介绍：</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-1.png" style="padding-left: 30px;padding-top: 10px;width:35%;height: auto">' +
              '<div style="padding-left: 20px">在控制台切换至检查工具所在文件目录下并输入如下命令：PmodelCheckTool.exe (pmodel文件路径) -o (输出路径)  使用检查工具打开pmodel文件，若未输入输出路径则默认可执行文件所在目录为输出路径。</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-2.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 20px">程序运行完毕后会在输出路径下生成名为“report.txt”的检查结果文件，输出内容展示如下：\n' +
              '\n</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-3.png" style="padding-left: 30px;padding-top: 10px;width:60%;height: auto">' +
              '<div style="padding-left: 20px">输出的检查信息将所有信息分为了三类：Error、Warning、Information，具体含义如下：</div>' +
              '<div style="padding-left: 40px">Error：将会导致模型无法加载的严重问题；</div>' +
              '<div style="padding-left: 40px">Waring：将会导致模型加载效率低、显示效果差的问题；</div>' +
              '<div style="padding-left: 40px">Information：文件关键信息提示，供相关方进行参考。</div>',
          },
        ],
      },
      {
        name: '工具下载及示例分析',
        id: '2',
        list: [
          {
            id: '1',
            time: '2021-08-10',
            q: '工具下载地址',
            a:
              '<div style="padding-left: 20px"><a href="http://www.pkpm.cn/product/download/downloadDetail?id=490" target="_black">点击下载pmodel检查工具</a></div>',
          },
          {
            id: '2',
            time: '2021-08-10',
            q: '示例分析',
            a:
              '<div style="padding-left: 20px">以实际项目案例中的pmodel文件进行示例分析，模型如下所示：</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-1.png" style="padding-left: 30px;padding-top: 10px;width:35%;height: auto">' +
              '<div style="padding-left: 20px">该模型的pmodel文件存在加载缓慢，初始视角很远等问题，现使用pmodel检查工具对其进行分析，得到的输出报告如下所示：</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-2.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 20px">根据检查报告可以发现，该文件存在以下问题：</div>' +
              '<div style="padding-left: 20px">1.摄像机数据有误</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-3.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 40px">只有当摄像机的视角（FOV值）为0时才会产生上述提示，可能是由于生成pmodel文件时未定义初始相机数据导致的。这是造成加载模型后初始视角很远的原因之一。</div>' +
              '<div style="padding-left: 20px">2.部分构件缺失几何信息</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-4.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 20px">3.构件的平均几何数过多，构件的几何组织过于细碎</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-5.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 40px">一般而言，构件上同一种材质的区域可以被合并为一个几何，而构件的组成材质种类并不会太多，因此一个构件所包含的几何数一般不会超过10个。而几何数量又会显著影响文件的加载速度，故该文件几何组织细碎是造成加载缓慢的原因之一。</div>' +
              '<div style="padding-left: 20px">4.不存在共享的几何，构件未进行实例化</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-6.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 40px">实例化是模型轻量化的重要手段，具体操作就是将相同的几何进行共享，以减少存储和加载的数据量，然而该文件并不存在共享的几何，故加载速度较慢。</div>' +
              '<div style="padding-left: 20px">5.构件无属性</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-7.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 20px">6.构件中存在材料相同且不被共享的几何</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-8.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 40px">当构件上的几何不与其他构件共享且材料相同时，可以考虑将这些几何合并以减少几何数量。</div>' +
              '<div style="padding-left: 20px">7.存在与主体模型偏离较远的构件</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-9.png" style="padding-left: 30px;padding-top: 10px;width:80%;height: auto">' +
              '<div style="padding-left: 40px">将输出信息提示的两构件在模型中找到，如下图所示</div>' +
              '<img src="../../../../static/img/commonQuestion/pmodel-sample-analysis-10.png" style="padding-left: 30px;padding-top: 10px;width:60%;height: auto">' +
              '<div style="padding-left: 40px">可以发现这两个构件与主体模型之间并无关联，为无效构件。该问题又会影响的模型的初始视角，由于该文件的初始摄像机数据有误，因此在打开此类文件时，图模大师会根据模型整体的包围盒数据重新定义初始视角，然而由于该模型存在几个离主体模型距离很远的无效构件，影响了模型整体的包围盒，从而影响初始视角。</div>',
          },
        ],
      },
    ],
  },
  {
    name: '二开说明',
    id: '11',
    children: [
      {
        name: '二开资料',
        id: '1',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台很好，但不清楚平台有哪些能力和开发资料？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台宣传册链接: <a href="https://tm.pkpm.cn/bimbox/p/share/12BxcmVTuu8/4uxwvZ4Ahcx/sSt5VUw9JE" target="_black">https://tm.pkpm.cn/bimbox/p/share/12BxcmVTuu8/4uxwvZ4Ahcx/sSt5VUw9JE</a></div>' +
              '<div style="padding-left: 20px">BIMBase云平台官网网址：<a href="../../../../" target="_black">https://cloud.pkpm.cn/</a></div>' +
              '<div style="padding-left: 20px">开发文档：<a href="../../../../devcenter/devdocs" target="_black">https://cloud.pkpm.cn/devcenter/devdocs</a></div>' +
              '<div style="padding-left: 20px">开发指南：<a href="../../../../devcenter/help/development-guide/docs/upload-model/docs/development-guide/" target="_black">https://cloud.pkpm.cn/devcenter/help/development-guide/docs/upload-model/docs/development-guide/</a></div>' +
              '<div style="padding-left: 20px">示例代码：<a href="../../../../playground/lod/?sampleID=selectBuild" target="_black">https://cloud.pkpm.cn/playground/lod/?sampleID=selectBuild</a></div>' +
              '<div style="padding-left: 20px">常见问题：<a href="../../../../devcenter/commonQuestion/" target="_black">https://cloud.pkpm.cn/devcenter/commonQuestion/</a></div>' +
              '<div style="padding-left: 20px">控制台：<a href="../../../../devcenter/console/myaccount" target="_black">https://cloud.pkpm.cn/devcenter/console/myaccount</a></div>' +
              '<div style="padding-left: 20px">控制台集成了构力BIMBase云平台上传、转换、预览、分享等基础能力，为用户搭建一个快速体验构力BIMBase云平台的线上环境。掌握了控制台的使用就是操作构力BIMBase云平台产品的第一步</div>' +
              '<div style="padding-left: 20px">首次试用BIMBase云平台二开基础流程，建议参考开发指南文档</div>',
          },
          {
            id: '2',
            time: '2023-04-11',
            q: '开发文档有很多，常用接口是哪些？',
            a:
              '<div style="padding-left: 20px">三维API及分类：<a href="../../../../devcenter/help/js-api/docs/demo-api/docs/demo-api/" target="_black">https://cloud.pkpm.cn/devcenter/help/js-api/docs/demo-api/docs/demo-api/</a></div>' +
              '<div style="padding-left: 20px">二维API及分类：<a href="../../../../devcenter/help/js-api/docs/2d/docs/2d-api/" target="_black">https://cloud.pkpm.cn/devcenter/help/js-api/docs/2d/docs/2d-api/</a></div>' +
              '<div style="padding-left: 20px">插件API及分类：<a href="../../../../devcenter/help/js-api/docs/addin-api/docs/addin-api/" target="_black">https://cloud.pkpm.cn/devcenter/help/js-api/docs/addin-api/docs/addin-api/</a></div>' +
              '<div style="padding-left: 20px">动画API及分类：<a href="../../../../devcenter/help/js-api/docs/animation/docs/animation-api/" target="_black">https://cloud.pkpm.cn/devcenter/help/js-api/docs/animation/docs/animation-api/</a></div>' +
              '<div style="padding-left: 20px"><a href="../../../../devcenter/help/server-api/docs/oauth2.0/" target="_black">服务API</a>请参考官网：</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/serviceAPI.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
          {
            id: '3',
            time: '2023-04-11',
            q: '如何快速验证BIMBase云平台（OBV）能力？',
            a:
              '<div style="padding-left: 20px">可使用控制台基础的文件上传、转换和轻量化查看、分享等功能。</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/console.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
        ],
      },
      {
        name: '二开名词',
        id: '2',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台开发文档中有一些名词介绍，不理解这些名词有作用，有完整的名词介绍吗？',
            a:
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/nounInterpretation.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
        ],
      },
      {
        name: '支持格式',
        id: '3',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台支持格式有很多，具体有哪些？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台支持的格式如下，支持70多种格式的轻量化解析处理，覆盖主流BIM格式，同时提供主流设计软件客户端插件，为BIMBase云平台的核心优势之一：</div>' +
              '<div style="padding-left: 20px"><a href="../../../../devcenter/commonQuestion/#9-1&1" target="_black">支持格式介绍</a></div>' 
          },
        ],
      },
      {
        name: '技术路线',
        id: '4',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台技术路线是什么？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台是可跨平台的三维模型、二维图纸等数据的轻量化展示组件，用户可在浏览器、手机端以及平板端进行轻量化浏览。</div>' +
              '<div style="padding-left: 20px">BIMBase云平台轻量化模型采用数据分片存储、属性数据通过编码压缩技术实现无损压缩、几何顶点数据去重、几何数据Draco无损压缩、几何共享等技术达到模型数据的轻量化存储及快速传输的目的。</div>' +
              '<div style="padding-left: 20px">BIMBase云平台在前端使用TypeScript开发语言以及WebGL图形渲染技术，配合轻量化模型采用几何数据合并+实例化渲染、Webworker并行计算处理、自主实现可编程渲染管线等技术手段，实现浏览器端数据的快速加载展示。</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/technologyRoadmap.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
        ],
      },
      {
        name: '开发语言和框架',
        id: '5',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台开发语言和框架是什么？',
            a:
              '<div style="padding-left: 20px">BIMBase轻量化平台由构力科技自主研发的轻量化引擎平台，基于WebGL技术实现。</div>' +
              '<div style="padding-left: 20px">对于二次开发用户，</div>' +
              '<div style="padding-left: 20px">1、一般前端部分用javascript语言开发，对于具体的开发框架没有要求；</div>' +
              '<div style="padding-left: 20px">2、服务接口为restful api形式，对具体开发语言没有要求，有相关商业用户使用java、.net、php等语言开发对应项目后端</div>',
          },
        ],
      },
      {
        name: '部署环境',
        id: '6',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台支持私有部署吗？部署要求有哪些？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台支持公有云、私有云以及混合云。</div>' +
              '<div style="padding-left: 20px">1、部署服务器配置参考：<a href="https://tm.pkpm.cn/bimbox/p/share/15kXKoOzLI6/4uxwvZ4Ahcx/5hQTvBRXqje/uZWf5j021b" target="_black">“构力BIMBase云平台私有部署配置要求”</a>，包括服务器配置、使用客户端配置需求。</div>' +
              '<div style="padding-left: 20px">2、由于不同项目需求不同，因此在正式部署前需要收集具体的部署需求，参考：<a href="https://tm.pkpm.cn/bimbox/p/share/wGstvnns4J/4uxwvZ4Ahcx/5hQTvBRXqje/qDG2h8uPtu/be836ac4-c915-b1d4-f10d-b4c6210684e2?version=8" target="_black">“构力BIMBase云平台部署需求文档”</a>。</div>' +
              '<div style="padding-left: 20px">3、对于面向多项目使用的场景，同时有批量文件上传转换，对转换效率，尤其是批量文件转换效率有较高要求，为满足批量任务并行调度执行效率要求，一般需要进行集群化部署，需要3主多从的kubernetes集群及多台转换服务器（具体台数需要根据具体需求进行评估），提高应用系统的稳定性、规模可伸缩性等。</a></div>' +
              '<div style="padding-left: 20px">4、BIMBase云平台（OBV）可以进行国产化部署，通过麒麟操作系统，鲲鹏/飞腾处理器，达梦/人大金仓数据库兼容测试及认证，已在建筑/电力/水利等行业多个项目进行使用；其中支持国产化部署的数据格式涵盖ifc/rvt/pmodel/gim/dwg/obj/3ds/dae/gltf/ms3d/x3d/xgl/pdf/doc系列/图片系列。</div>',
          },
        ],
      },
      {
        name: '功能和能力分类',
        id: '7',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）有功能介绍吗？',
            a:
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/functionIntroduction.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
          {
            id: '2',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）有没有支持场景介绍？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台（OBV）提供<a href="../../../../devcenter/commonQuestion/#11-7&1" target="_black">“轻量化展示相关能力”</a>，提供平台能力。基于平台能力，结合用户业务场景可以搭建包括可视化建设管理、可视化BIM审查、可视化设计协同、数字建造、数字运维、绿建分析、水利建设管理、交通建设等方面平台或项目，同时可以收集数据、应用数据及导出数据给其他平台，可以基于BIMBase云平台（OBV）基础能力开发数据汇集、数据资产管理、数据可视化应用及数据发布全链条功能。</div>',
          },
        ],
      },
      {
        name: '性能',
        id: '8',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）性能怎么样？',
            a:
              '<div style="padding-left: 20px">三维资源管理平台主要性能点体现在模型数据转换时间和模型浏览交互的流畅程度上，BIMBase云平台（OBV）性能指标情况如下：</div>' +
              '<div style="padding-left: 20px">以CPU为Intel Core i7-7700、显卡为NVIDIA GTX1060、内存为16G的个人电脑为例，在开启缓存情况下，主流格式加载时间统计如下：</div>' +
              '<div style="padding-left: 20px"><img src="../../../../static/img/commonQuestion/performanceEfficiency.png" style="padding-left: 30px;padding-top: 10px;height: auto"></div>',
          },
          {
            id: '2',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）最大模型承载力是多少？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台流式模式通过LOD技术可以提高模型承载力。理论上在推荐配置电脑下，模型承载力有非常大的提升，目前经过充分测试验证的是5亿三角面级模型的加载。</div>',
          },
          {
            id: '3',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）模型轻量化压缩率最高能达到多少？',
            a:
              '<div style="padding-left: 20px">轻量化压缩率和模型源格式数据组织、压缩技术有关系；对于主流格式（RVT/IFC/GIM等），BIMBase云平台轻量化数据的压缩率一般为10~30%。</div>',
          },

        ],
      },
      // {
      //   name: '接口清单',
      //   id: '9',
      //   list: [
      //
      //   ],
      // },
      {
        name: '其他',
        id: '9',
        list: [
          {
            id: '1',
            time: '2023-04-11',
            q: 'BIMBase云平台（OBV）有强大的数据处理能力，那能不能作为数据贯通平台使用呢？',
            a:
              '<div style="padding-left: 20px">BIMBase云平台（OBV）支持70余种格式的轻量化解析，覆盖主流BIM格式，能够较好的承载和消化主流设计软件及平台数据，<a href="../../../../devcenter/commonQuestion/#11-3&1" target="_black">详见支持格式</a>。</div>' +
              '<div style="padding-left: 20px">同时，为方便对外发布和提供模型数据，BIMBase云平台（OBV）提供3dTiles数据服务对外发布数据，目前已应用于建筑/电力等行业的多个项目，支持在Cesium/超图平台中使用，打通平台间模型数据流转环节。</div>' +
              '<div style="padding-left: 20px">此外还提供LODSDK、PModelSDK开发包解析PTiles和Pmodel数据，以更方便的对轻量化数据进行加工处理和使用，目前已在多个项目和友商产品中集成使用。</div>',
          }
        ],
      },
    ],
  },
]

export { Data }



// WEBPACK FOOTER //
// ./src/pages/devCenter/commonQuestion/data.js